import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import ThemeToggle from './ThemeToggle';
import './Header.css';

const Header = () => {
  const location = useLocation();

  return (
    <motion.header 
      className="header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: [0.19, 1, 0.22, 1] }}
    >
      <div className="header-container">
        <Link to="/" className="logo-link">
          <motion.div 
            className="logo"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <span className="logo-icon">🎁</span>
            <div className="logo-text">
              <span className="logo-primary">Lucky</span>
              <span className="logo-secondary">Box</span>
            </div>
          </motion.div>
        </Link>

        <nav className="nav">
          <NavLink to="/" label="Home" isActive={location.pathname === '/'} />
          <NavLink to="/history" label="My Bets" isActive={location.pathname === '/history'} />
        </nav>

        <div className="header-actions">
          <ThemeToggle />
        </div>
      </div>
    </motion.header>
  );
};

const NavLink = ({ to, label, isActive }) => (
  <Link to={to} className={`nav-link ${isActive ? 'active' : ''}`}>
    <motion.span
      whileHover={{ y: -2 }}
      whileTap={{ y: 0 }}
    >
      {label}
    </motion.span>
    {isActive && (
      <motion.div
        className="nav-indicator"
        layoutId="navIndicator"
        transition={{ type: 'spring', stiffness: 500, damping: 35 }}
      />
    )}
  </Link>
);

export default Header;

